import { useDevLogBi } from "./../ricos-context";
const useBiNext = () => {
  const devLogBi = useDevLogBi();
  const logBi = (args) => {
  };
  return devLogBi || logBi;
};
export {
  useBiNext
};
//# sourceMappingURL=use-bi-next.js.map
